<template>
    <div class="row pt-2 pb-2 event-answer-grid">
        <div class="w-100" v-for="(choice, key) in $store.state.game.question.question.choices">
            <!--choice :id="key" :choice="choice" @click="send_activity(key)"></choice-->
            <ChoiceV1 :id="key" :choice="choice" @click="send_activity(key)"></ChoiceV1>
        </div>
    </div>
</template>

<script>
import ChoiceV1 from '@/components/ChoiceV1.vue';
export default {
    name: "Quiz",
    components: {
        //Choice,
        ChoiceV1
    },
    data(){
        return {
            utils: require("../../../../shared/utils"),
            selected_choices: []
        };
    },
    mounted() {
        let activity = this.user_activity();            
        if(activity == null) 
            return;
        this.selected_choices = activity.choice;
    },
    methods:{
        user_activity(){
            let user_data = this.$store.state.game.clients.find((cli) => {
                return cli.username == this.$store.state.game.user.username;
            });
            if(user_data)
            {
                if(user_data.data)
                {
                    let activity = user_data.data.find((q) => {
                        return q.question == this.$store.state.game.current_question
                    })
                    return activity;
                }
            }
        },
        send_activity(choice){
            if (this.$store.state.game.user?.role !== this.utils.USER_ROLES.PLAYER) return;
            let activity = this.user_activity();
            
            // If we already have activity data then return, no need to save activity response.
            if(activity != null) {
                this.selected_choices = activity.choice;
                return;
            }
            
            // If we are in result view then just return, no need to save activity response.
            if(this.$route.name == "Result") 
                return;

            this.selected_choices = [choice];

            // Reliable send: a lost "answer" packet on a flaky tablet connection
            // directly costs the player their score for this question, unlike the
            // high-frequency state broadcasts which are fine to miss and resync later.
            window.network.send_reliable(window.RPC.UPDATE_ACTIVITY, {
                question: this.$store.state.game.question.question.id,
                choice: this.selected_choices,
                timestamp: Date.now()
            }, {
                onFail: () => window.toast.error("No se ha podido enviar tu respuesta, comprueba tu conexión.")
            });
        }
    }
}
</script>

<style>

</style>